const validate = (attrs = {}) => {
  const errors = {};

  if (!attrs.profesorContenido || !attrs.profesorContenido.value) {
    errors.profesorContenido = 'Debe seleccionar un profesor';
  }

  if (!attrs.tipoClase || !attrs.tipoClase.value) {
    errors.tipoClase = 'Debe seleccionar el tipo clase';
  }

  if (!attrs.fecha) {
    errors.fecha = 'Debe seleccionar una fecha';
  }

  if (!(attrs.modalidad && attrs.modalidad.value)) {
    errors.modalidad = 'Debe seleccionar una modalidad';
  }

  if (!attrs.contenidos) {
    errors.contenidos = 'Debe ingresar un contenido';
  }

  if (!attrs.unidad) {
    errors.unidad = 'Debe ingresar un contenido';
  }

  if (!(attrs.metodologias && attrs.metodologias.length && attrs.metodologias.some(m => m.selected))) {
    errors.metodologias = 'Debe seleccionar una metodología';
  }

  if (!(attrs.tiposContenidos && attrs.tiposContenidos.length)) {
    errors.tiposContenidos = 'Debe seleccionar al menos un tipo de contenido';
  }

  return errors;
};

export default validate;
